function StatCard({ label, value, icon }) {
    return (
        <div className="flex flex-col items-center p-3 border border-gray-200 rounded-lg min-w-0">
            <span className="text-lg mb-1">{icon}</span>
            <span className="text-xl font-bold text-gray-800">{value}</span>
            <span className="text-xs text-gray-500 text-center">{label}</span>
        </div>
    );
}

function ProgressOverview({ overview }) {
    if (!overview) {
        return null;
    }

    const streak = overview.learning_streak_days ?? 0;
    const videosCompleted = overview.videos_completed ?? 0;
    const qaSessions = overview.qa_sessions ?? 0;
    const avgChatScore = overview.avg_chat_score ?? 0;

    const tiles = [
        streak > 0 && {
            key: 'streak',
            icon: '🔥',
            label: 'Day streak',
            value: `${streak}d`,
        },
        videosCompleted > 0 && {
            key: 'videos',
            icon: '📺',
            label: 'Videos watched',
            value: videosCompleted,
        },
        qaSessions > 0 && {
            key: 'qa',
            icon: '💬',
            label: 'Q&A sessions',
            value: qaSessions,
        },
        avgChatScore > 0 && {
            key: 'score',
            icon: '⭐',
            label: 'Avg chat score',
            value: avgChatScore.toFixed(1),
        },
    ].filter(Boolean);

    if (tiles.length === 0) {
        return null;
    }

    return (
        <div className="bg-white border border-gray-300 rounded-lg p-5">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">Overview</h2>
            <div className="grid grid-cols-4 md:grid-cols-2 gap-3">
                {tiles.map((tile) => (
                    <StatCard
                        key={tile.key}
                        icon={tile.icon}
                        label={tile.label}
                        value={tile.value}
                    />
                ))}
            </div>
        </div>
    );
}

export default ProgressOverview;
